export default "__VITE_ASSET__66c536d9__"